export const stringsMixin = {
    methods: {
        convertNewlinesToBreaks: function (text) {
            if (!text || typeof text !== 'string' || text.trim() === '') {
                return '';
            }
            return text.replace(/\n/g, '<br/>');
        },
    }
};